/**
 * Erkennt, ob ein Steuer-ID-Feld vermutlich eine Steuernummer (Finanzamt-/
 * Gewerbesteuernummer, z.B. "123/123/12345") statt der 11-stelligen persönlichen
 * Steuer-Identifikationsnummer (IdNr., nur Ziffern) enthält. Die IdNr. enthält NIE
 * einen Schrägstrich — das ist ein eindeutiges, false-positive-freies Signal.
 */
export function istVermutlichSteuernummerStattIdnr(value: string | null | undefined): boolean {
  return (value ?? '').includes('/');
}
